import type { LinkStoryblok, MultilinkStoryblok } from '@/storyblok/component-types-sb'
import type { ISbStoryData } from 'storyblok'
import type { ISbLink } from '@/storyblok/types'

export function getCompactLinkData(
  link: string | LinkStoryblok | ISbStoryData<LinkStoryblok> | MultilinkStoryblok | undefined
): ISbLink {
  if (!link || typeof link === 'string') {
    return { href: '', text: '', external: false, target: '_self', name: '' }
  }

  const isStory = 'content' in link

  const href = isStory ? link.content?.href : link.href
  const url = href?.url || href?.cached_url || ''
  const text = isStory ? link.content?.text ?? '' : link.text ?? ''
  const target: ISbLink['target'] = href?.target === '_blank' ? '_blank' : '_self'

  return {
    href: url,
    text: text,
    external: true,
    target,
    name: link.name ?? ''
  }
}
